import {t,useLanguage} from '../i18n';
import React from 'react';
import './BenefitsLoading.css';

export default function BenefitsLoading({busy, hasRows, error, onRetry, title}) {
  useLanguage();
  return <>
    <div className="benefits-update" aria-live="polite">
      {error ? <><span>{t("No pudimos actualizar.")}</span><button type="button" onClick={onRetry} disabled={busy}>{t("Reintentar")}</button><details><summary>{t("Detalle")}</summary><p>{t(error)}</p></details></>
        : busy && hasRows ? <><span className="benefits-spinner" aria-hidden="true"/><span>{t("Actualizando…")}</span></> : null}
    </div>
    {busy && !hasRows && !error && <div className="benefits-skeleton-list" role="status" aria-label={t("Cargando {title}",{title})}>
      {[0,1].map(i=><div className="benefits-skeleton" key={i} aria-hidden="true"><div className="benefits-skeleton-head"><i/><div><b/><b/></div></div><div className="benefits-skeleton-body"/><b/></div>)}
    </div>}
  </>;
}
